import styled from "styled-components";
import { appearModal } from "../../../constants/animationConstants";

export const OnCloseArea = styled.div`
  width: 200vw;
  height: 122vh;
  position: absolute;
  margin-right: -200px;
  margin-top: -120px;
  z-index: 1;
  cursor: auto;

  @media (min-width: 768px) {
    height: 200vh;
  }

  @media (min-width: 1140px) {
    height: 112vh;
  }
`;

export const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  background: #f7f8fc;
  border-radius: 8px;
  margin-top: 26px;
  z-index: 1;
  animation: ${appearModal} .2s linear;
  margin: 30px 9px 0 0;
`;

export const FlagWrapper = styled.div`
  background: #f7f8fc;
  padding: 10px 15px;

  :first-child {
    border-radius: 8px 8px 0 0;
  }

  :last-child {
    border-radius: 0 0 8px 8px;
  }

  :hover {
    background: #deedff;
  }

  :active {
    background: #cbe1fd;
  }
`;

export const Flag = styled.img`
  display: block;
  width: 20px;
`;
